import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { PaymentCreditCard } from 'src/app/models/payment/payment-card.model';

import * as lodash from 'lodash';

@Component({
  selector: 'app-package-payment-selection',
  templateUrl: './package-payment-selection.component.html',
  styleUrls: ['./package-payment-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PackagePaymentSelectionComponent implements OnInit {
  // #region -> Property <-
  // ----------

  @Input() primaryPaymentCreditCard$: Observable<PaymentCreditCard>;
  primaryPaymentCreditCard: PaymentCreditCard;
  primaryPaymentCreditCardSubscription: Subscription;

  @Input() otherPaymentCreditCardList$: Observable<PaymentCreditCard[]>;
  otherPaymentCreditCardList: PaymentCreditCard[];
  otherPaymentCreditCardListSubscription: Subscription;

  @Input() selectedPaymentCreditCard: PaymentCreditCard;
  @Output() selectionChange = new EventEmitter<PaymentCreditCard>();

  @Output() changeStep = new EventEmitter<number>();

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Constructor <-
  // ----------

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
  ) {

  }

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Lifecycle <-
  // ----------

  ngOnInit() {
    this.primaryPaymentCreditCardSubscription = this.primaryPaymentCreditCard$.subscribe(
      (newPrimaryCard) => {
        this.primaryPaymentCreditCard = lodash.cloneDeep(newPrimaryCard);

        // Trigger change detection when mutated.
        this.changeDetectorRef.markForCheck();
      }
    );

    this.otherPaymentCreditCardListSubscription = this.otherPaymentCreditCardList$.subscribe(
      (newCardList) => {
        this.otherPaymentCreditCardList = [...newCardList];

        // Trigger change detection when mutated.
        this.changeDetectorRef.markForCheck();
      }
    );
  }

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Method <-
  // ----------

  setSelectedPaymentMethod(card: PaymentCreditCard) {
    //
    this.selectedPaymentCreditCard = card;
  }

  onSave() {
    //
    this.selectionChange.emit(this.selectedPaymentCreditCard);

    // Back to "Checkout" page
    this.changeStep.emit(4);
  }

  // ----------
  // #endregion

  /////////////////////////////

}
